import React, { useEffect, useState } from "react";
import disableScroll from "disable-scroll";
import "./Popup.scss";
// import Input from "../Input";
import { Rating } from "semantic-ui-react";
import moment from "moment";
import { addLogsHistory, logsAdd } from "../../../services/firebase/firestore/saveData";
import { getLogsHistory } from "../../../services/firebase/firestore/getData";


let InputRepetitions = ({ repetitionsArr }) => {
  let [repetitions, setRepetitions] = useState("")
  const handelSetRepetetitions = (e, i) => {
    console.log("index", i)
    setRepetitions(e.target.value)
    repetitionsArr.push(e.target.value)
    console.log("reeee", repetitionsArr)
  }
  return (
    <div className="loging-input-block" style={{ marginRight: "7px" }}>

      <label className="loging-input-label">Repetitions</label>

      <input className="loging-inputs" name={`repetitions`} value={repetitions} onChange={handelSetRepetetitions} />

    </div>
  )
}

let InputResistance = ({ resistanceArr }) => {
  let [resistance, setResistance] = useState("")
  const handleResistance = (e) => {
    setResistance(e.target.value)
    resistanceArr.push(e.target.value)
    console.log("resistance arr", resistanceArr)
  }
  return (
    <div className="loging-input-block" style={{ marginRight: "7px" }}>

      <label className="loging-input-label">Load</label>

      <input className="loging-inputs" value={resistance} onChange={handleResistance} />
    </div>
  )
}

let SliderRirs = ({ rirs, rirVal }) => {
  let [rirSlider, setRirSlider] = useState(0)
  let handleRirSlider = (e) => {
    setRirSlider(e.target.value)
    rirs.push(e.target.value)
    console.log("rirs", rirs)
  }
  return (
    <div className="loging-input-block" style={{ marginTop: "7px" }}>

      <label className="loging-input-label">RIR:{rirSlider ? rirSlider : rirVal}</label>
      {/* <input className="loging-inputs" value={""} /> */}
      <input
        type='range'
        min={0}
        max={10}
        // step={0.1}
        value={rirSlider ? rirSlider : rirVal}
        onChange={handleRirSlider}
      /><br />
      {/* <Rating rating={proteinSlider} maxRating={5} /> */}
      <Rating rating={rirSlider ? rirSlider : rirVal} maxRating={10} />
    </div>

  )
}
let SliderRpes = ({ reps, rpeVal }) => {
  let [rep, setRep] = useState(0)
  const handelRepSlider = (e) => {
    setRep(e.target.value)
    reps.push(e.target.value)
    console.log("reps", reps)
  }
  return (
    <div className="loging-input-block" style={{ marginTop: "7px", marginRight: "7px" }}>

      <label className="loging-input-label">RPE: {rep ? rep : rpeVal}</label>

      <input
        type='range'
        min={0}
        max={10}
        // step={0.1}
        value={rep ? rep : rpeVal}
        onChange={handelRepSlider}
      /><br />

      <Rating rating={rep ? rep : rpeVal} maxRating={10} />
    </div>
  )

}

let Notes = ({idx, notes, setNotes, NotesVal }) => {
  let [note, setNote] = useState("")

  const handleNotes = (e,i) => {
    setNote(e.target.value);
    console.log("idx notes val",i)
    notes.splice(i,1,e.target.value)
    setNotes(notes)
    // if (note.length >= 1) {
    //   let arr=[]
    //   notes.push(e.target.value);
    //   // arr.splice(idx,1, e.target.value);
    //   console.log("notes", arr,idx)
    //   setNotes(notes)
    // }
    // setNotes([...e.target.value])
    //   console.log("notes", notes)

  }
  return (
    <div className="loging-input-block" style={{}}>

      <label className="loging-input-label">Notes</label>

      <textarea className="loging-notes" style={{ width: "100%" }} value={note ? note : NotesVal || ""} onChange={(e)=>handleNotes(e,idx)}></textarea>

    </div>
  )
}

export default function Popup({ exerciseId,date, getLogs, setLoggingBtn, supersets, client_id, isSetLoging, sets, savePopup, onCancel, onAction, title, button, deletePopup, description }) {
  let [repetitionsArr, setRepetitionsArr] = useState([])
  let [resistanceArr, setResistanceArr] = useState([])
  let [rirs, setRirs] = useState([])
  let [reps, setReps] = useState([])
  let [notes, setNotes] = useState([])
  const [exId, setExId] = useState("")
  const [exIdx, setExidx] = useState("")
  const [setsId, SetsetId] = useState("")
  let [repeat, setRepeat] = useState(1)
  let [idsObj, setIdsObj] = useState({})
  let [notesVal, setNotesVal] = useState("")
  const [logshistory,setHistory]=useState({clientID:client_id,history:[]})
  let [filterOutHistoryData,setFilterOutHistoryData]=useState([])
  const handleNotes = (e, i) => {
    // setNotesVal(e.target.value)
    notes[i] = e.target.value
    setNotes([...notes])
    setNotesVal(notes[i])
    console.log("notess", notes)
  }
  useEffect(() => {
    // debugger
    console.log("history time",date)
    getLogsHistory(client_id,exerciseId,res=>{
      if (res) {
        setHistory(res)
        console.log("exercies_history",res.history)
        let filters= res.history.filter((data)=>data.date==date)
        setFilterOutHistoryData(filters)
        console.log("filter_out_hist",filters)
     
      } else {
        // setLogSetsHistory(result);
        // setHistory({
        //   clientID: client_id,
        //   history: [],
        // });
      }
      // if(res){
       
      // }
      
    })

    if (getLogs || supersets) {
      console.log("super sets", supersets)

      // console.log("getLogs", getLogs[`${exId}`])
      console.log("getLogs", getLogs)
      for (let i = 0; i < supersets.length; i++) {

        for (let j = 0; j < supersets[i].exercises.length; j++) {
          if (supersets[i].exercises[j].exercise_id && supersets[i].exercises[j].id && supersets[i].id) {
            return {
              setId: SetsetId(supersets[i].id),

              exId: setExidx(supersets[i].exercises[j].id),
              exIdx: setExId(supersets[i].exercises[j].exercise_id)
            }
          }
        }
      }
    } else {

    }


  }, [supersets, getLogs,date])

  console.log("setsss",sets)

  const handelSave = () => {
    let date = new Date()
    let formatedDate = moment(date).format("YYYY-MM-DD")
    // console.log("date",moment(date).format("YYYY-MM-DD"))
    const data = {
      repetitions: repetitionsArr,
      weight: resistanceArr,
      notes: notes,
      rirs: rirs,
      rpes: reps,
      exId: exId,
      setIdx: setsId,
      exIdx: exIdx,
      repeat: repeat,
      // date:"2023-03-10"
    };
    console.log("save resp", data)
    
    logsAdd(client_id, formatedDate, data, res => {
      console.log("Your record is added", res)
      // onAction()
      setLoggingBtn(false)
    })
   
    if(logshistory){
      // let arr=[]
      let prevState={
        clientID:client_id,
        history:[]
      }
      prevState.history.push({
        repetitions: repetitionsArr,
        weight: resistanceArr,
        notes: notes,
        rirs: rirs,
        rpes: reps,
        exId: exId,
        setIdx: setsId,
        exIdx: exIdx,
        repeat: repeat,
        date:formatedDate
      })
      
      setHistory(prevState)
      console.log("hisisisi",prevState.history.concat(logshistory?.history))
      // setTimeout(()=>{

      // },1000)
     addLogsHistory(client_id,exerciseId,prevState,res=>{
      // debugger
      console.log("addlogshistory",res)
    })
     
    }else{
      // let arr=[]
      // arr.push({repetitions: repetitionsArr,
      //   weight: resistanceArr,
      //   notes: notes,
      //   rirs: rirs,
      //   rpes: reps,
      //   exId: exId,
      //   setIdx: setsId,
      //   exIdx: exIdx,
      //   repeat: repeat,
      //   date:"2023-03-10"
      // })
      // let obj={
      //   clientID: client_id,
      //   history: arr,
      // }
      // setHistory(obj);
      // setTimeout(()=>{

      //   console.log("data history",logshistory)
      // },1000)
    }
    // logshistory.history.push(data)
    // setTimeout(()=>{
     
    // },1000)
    // addLogsHistory(client_id,exerciseId,history,res=>{
    //   debugger
    //   console.log("addlogshistory",res)
    // })
  }
  useEffect(() => {
    // disableScroll.on();
    return () => {
      // disableScroll.off();
    };
  }, []);
  let setLogs = []
  let j = 3;
  for (let i = 0; i < sets; i++) {
    // debugger
    setLogs.push(
      <div className="set-logging-popup">
        <div style={{ marginTop: "5px", marginBottom: "5px" }}>
          <span className="set-heading" >Set {i + 1} </span>
          <div className="calorie-settings" style={{ justifyContent: "space-between", width: "100%" }}>
           
            <InputRepetitions repetitionsArr={repetitionsArr} />
            <InputResistance resistanceArr={resistanceArr} />
           

          </div>

          <div className="calorie-settings" style={{ width: "80%", justifyContent: "space-between", marginTop: "5px", marginBottom: "5px" }}  >
            <SliderRirs rirs={rirs} />
          
            <SliderRpes reps={reps} />
            
          </div >
          <Notes idx={i} notes={notes} setNotes={setNotes} />
        
        </div>
      </div>)

  }


  return (
    <>
      <div className="c-popup-back" onClick={() => onCancel()} />
      <div className={`c-popup ${deletePopup ? "--delete" : ""}`}>
        {isSetLoging ?
          <h1 style={{ color: "rgb(0, 189, 165)" }}>{title}</h1> :
          <h1>{title}</h1>
        }
        <p>{isSetLoging ? "" : description}</p>

        {
          isSetLoging && sets > 0 ?
            // console.log("gegeggegeg",getLogs[`${exId}`])
            <div style={{ overflowY: "scroll", height: "400px" }} >
              {/* {getLogs[`${exId}`] ? getLogs[`${exId}`].repetitions.map((data, j) => { */}
              {filterOutHistoryData?.length>0?filterOutHistoryData[0].repetitions?.map((data, j) => {
                console.log("hsitor data",data)
                return (
                  <div className="set-logging-popup" >
                    <span className="set-heading" >Set {j + 1} </span>
                    <div className="calorie-settings" style={{ justifyContent: "space-between", width: "100%" }}>
                      <div className="loging-input-block" style={{ marginRight: "7px" }}>

                        <label className="loging-input-label">Repetitions</label>
                        <input className="loging-inputs" value={data} />
                      </div>

                      <div className="loging-input-block" style={{ marginRight: "7px" }}>

                        <label className="loging-input-label">Resistance</label>
                        <input className="loging-inputs" value={filterOutHistoryData[0].weight[j]} />
                      </div>

                    </div>

                    <div className="calorie-settings" style={{ width: "80%", justifyContent: "space-between", marginTop: "5px", marginBottom: "5px" }}  >

                      <div className="loging-input-block" style={{ marginTop: "7px" }}>
                        <SliderRirs rirVal={filterOutHistoryData[0].rirs[j]} />

                      </div>

                      <div className="loging-input-block" style={{ marginTop: "7px" }}>
                        <SliderRpes rpeVal={filterOutHistoryData[0].rpes[j]} />

                      </div>

                    </div >
                    <Notes NotesVal={filterOutHistoryData[0].notes[j]} />
                  </div>
                )
              }) :
              // history.length > 0 ? history.map((data, i) => {
                setLogs.length > 0 ? setLogs.map((data, i) => {
                  // console.log("map data",data)
                  return (<div key={i}>
                    {data}
                  </div>)
                }) : ""
              }


            </div>
            : <span>{isSetLoging && "No set logging data available"}</span>
        }

        <div className="c-btn-close-collection">
          <button className="c-cancel-btn" onClick={() => onCancel()}>
            Cancel
          </button>
          {sets > 0 ?
            <button className={isSetLoging ? `c-save-btn ${deletePopup ? "--save" : ""}` : `c-close-btn ${deletePopup ? "--delete" : ""}`} onClick={isSetLoging ? handelSave : () => onAction()}>
              {button}
            </button> :
            (button == "Delete"||button== "Remove")?
              <button className={isSetLoging ? `c-save-btn ${deletePopup ? "--save" : ""}` : `c-close-btn ${deletePopup ? "--delete" : ""}`} onClick={isSetLoging ? handelSave : () => onAction()}>
                {button}
              </button> : ""
          }

          {/* {
            isSetLoging?
            <button className={`c-save-btn ${deletePopup ? "--save" : ""}`} onClick={() => onAction()}>
            {button}
          </button>:""
          } */}

        </div>
      </div>
    </>
  );
}
